import axios from "axios";

export default async ({ url = null, params = null }) => {
  if (!(url && params)) {
    console.error("Не передан url или params");
    return;
  }

  const current_url =
    process.env.NODE_ENV === "production"
      ? url
      : `http://localhost:3004/${url}`;

  return await axios
    .get(current_url, {
      params
    })
    .then(res => res.data || {});
};
